import {Component, EventEmitter, Input, Output} from "@angular/core";
import {DesignSystemModule} from "../../../design-system/design-system.module";
import {CommonModule, NgForOf, NgIf, NgOptimizedImage, SlicePipe} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {Announcement} from "../../../../services/announcement.service";

@Component({
  selector: 'app-announcement-line',
  template: `
      <div class="single-announcement"
		   (click)="openAnnouncement(announcement, 'read')"
           [class.mt-s]="!first">
          <div class="announcement-table h-100">
              <div class="flex-align-center gap-XS" style="width: 45%; min-width: 45%;">
                  <div class="disp-f a-i-c" style="width: 48px; min-width: 48px;">
                      <div class="logo-bubble w-100">
                          <img *ngIf="announcement.type === 'general'" class="filter-accent"
                               ngSrc="assets/icons/message-alert-square.svg" height="20" width="20" alt="">
                          <img *ngIf="announcement.type === 'sensitization'" class="filter-accent"
                               ngSrc="assets/icons/sensitization_announcement.svg" height="20" width="20" alt="">
                      </div>
                  </div>
                  <div class="disp-f a-i-c">
                      <div class="disp-f f-d-col j-c-c w-100 gap-XS overflow-hidden" style="max-width: 200px">
                            <span class="font-M fw-700 text-overflow-ellipsis">
                                {{ announcement.title }}
                            </span>
                          <span class="font-M fw-500 text-overflow-ellipsis">{{ 'global.day.' + (announcement.startDate.getDay() == 0 ? '7' : announcement.startDate.getDay().toString()) | translate }} {{ announcement.startDate.getDate() }} {{ 'global.month.' + (announcement.startDate.getMonth() + 1) | translate }} {{ announcement.startDate.getFullYear() }}</span>
                      </div>
                  </div>
              </div>
              <div class="disp-f a-i-c" style="width: 10%; min-width: 10%;">
                  <app-display-logo *ngIf="announcement.app" [tooltip]="announcement.app.name" tooltipPosition="right"
                                    [logo]="announcement.app.logo" [size]="40"></app-display-logo>
                  <div *ngIf="announcement.teams && announcement.teams.length > 0" class="disp-f f-d-r a-i-c j-c-s"
                       style="padding-left: 16px">
                      <div class="disp-f f-d-r a-i-c j-c-s"
                           [tooltipTriggerFor]="tooltip1" tooltipPosition="right"
                           [tooltipDisabled]="!announcement.teamsTooltip?.length">
                          <div *ngFor="let team of announcement.teams | slice:0:1;let i = index"
                               style="margin-left: -16px;" [style.z-index]="5 + i">
                              <div class="disp-f a-i-c j-c-c col bkg-accent-light radius-half white-border"
                                   style="height: 38px; width: 38px">
                                  <img [src]="!!$any(team)?.icon ? '/assets/icons/team_icon/' + $any(team)?.icon + '.svg' : 'assets/icons/team.svg'"
                                       class="svg-22 filter-accent">
                              </div>
                          </div>
                          <div *ngIf="announcement.teams.length > 1"
                               class="disp-f a-i-c j-c-c col bkg-accent-light radius-half white-border"
                               style="height: 38px; width: 38px; margin-left: -16px; z-index: 8">
                              <span class="font-M fw-500 accent">+{{ announcement.teams.length - 1 }}</span>
                          </div>
                      </div>
                      <app-tooltip #tooltip1>
                          <div class="flex-column" *ngFor="let structure of announcement.teamsTooltip">
                              <span class="fw-700">{{ structure.parentName }}</span>
                              <ul class="pl-l pr-l">
                                  <li class="font-S" [ngClass]="{'mb-s': i + 1 < structure.teams.length}"
                                      *ngFor="let team of structure.teams; let i = index">{{ team.name }}
                                  </li>
                              </ul>
                          </div>
                      </app-tooltip>
                  </div>
              </div>
              <div class="disp-f a-i-c" style="width: 10%; min-width: 10%;">
                  <app-chips-count [value]="announcement.seenCount" type="visibility" color="accent"></app-chips-count>
              </div>
              <div class="disp-f a-i-c">
                  <div class="flex-align-center gap-XS pad-left-S pad-right-M horizontal-bar-L color-grey mr-l"
                       style="cursor:default;">
                      <img src="assets/icons/thumb-up.svg" width="14.6" height="14.6" alt=""/>
                      <span class="font-M fw-500">{{ !announcement.likeCount ? '-' : announcement.likeCount }}</span>
                  </div>
                  <div class="flex-align-center gap-XS pad-left-S pad-right-M horizontal-bar-L color-grey"
                       style="cursor:default;">
                      <img src="assets/icons/thumb-down.svg" width="14.6" height="14.6" alt=""/>
                      <span class="font-M fw-500">{{ !announcement.dislikeCount ? '-' : announcement.dislikeCount }}</span>
                  </div>
              </div>
              <div class="disp-f a-i-c" style="width: 10%;">
                  <div class="disp-f a-i-c j-c-fe w-100" style="height: 100%;">
                      <app-icon-button *ngIf="!readonly" color="accent" size="m" [img]="'assets/icons/edit.svg'"
                                       [tooltip]="'button.edit'|translate" [panelClass]="'fix-edit-margin'"
                                       (click)="$event.stopPropagation();openAnnouncement(announcement, 'write')">
                      </app-icon-button>
                      <app-icon-button *ngIf="!readonly" color="danger" size="m" [img]="'assets/icons/trash.svg'"
                                       [tooltip]="'button.delete'|translate"
                                       (click)="deleteAnnouncement(announcement.id)">
                      </app-icon-button>
					  <div *ngIf="readonly" class="flex-align-center mr-s read-only-arrow">
						  <img src="assets/icons/arrow-right-black.svg" class="filter-grey">
					  </div>
                  </div>
              </div>
          </div>
      </div>
  `,
  imports: [
    DesignSystemModule,
    CommonModule,
    TranslateModule,
    NgOptimizedImage
  ],
  styles: [`
    @use "src/variables" as *;

    .single-announcement {
      border-radius: 10px;
      border: 1px solid #F2F2F7;
      background: #FFF;
      padding: 0 13px;
      height: 62px;
      flex-shrink: 0;
		transition: border 0.2s ease-in-out;

		&.single-announcement {
			cursor: pointer;

			&:hover {
				border: 1px solid $k-bordergrey;

				.read-only-arrow {
					opacity: 1;
				}
			}
		}

      .logo-bubble {
        flex-shrink: 0;
        display: flex;
        width: 38px;
        height: 38px;
        align-items: center;
        justify-content: center;
        border-radius: 7.445px;
        background: $k-accent-light;
      }
    }

	.read-only-arrow {
		opacity: 0;
		transition: opacity 0.2s ease-in-out;
	}

    .seen-count {
      gap: 5px;
      padding: 0 10px;
      color: $k-accent;
      background: rgba(61, 192, 255, 0.1);
      border-radius: 20px;
    }

    .announcement-table {
      display: flex;
      justify-content: space-between;
    }

    .color-grey {
      color: $k-grey;
      background-color: $k-lightgrey-2;

      img {
        filter: $k-grey-filter;
      }
    }
  `]
})
export class AnnouncementLineComponent {
  @Input() announcement: Announcement;
  @Input() first: boolean;

  @Input() readonly: boolean = false;

  @Output() deleted = new EventEmitter<string>();
  @Output() open = new EventEmitter<{ announcement: Announcement, mode: 'read' | 'write' }>();

  deleteAnnouncement(announcement: string): void {
    this.deleted.emit(announcement);
  }

  openAnnouncement(announcement: Announcement, mode: 'read' | 'write'): void {
    this.open.emit({ announcement: announcement, mode: mode });
  }
}
